module.exports = __webpack_public_path__ + "img/portrait-059.27bc6a97.jpg";